import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { teleConsultationModel } from "../Axios/AxiosConfig";
import TeleConsultationStore from "../DataRepository/TeleConsultationStore";
import { useNavigate } from "react-router-dom";
import { profileModel } from "../Axios/AxiosConfig";
import LoadingComponent from "../loading"

import Cookies from "js-cookie";

const EditProfile = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const doctorDetailsCookie = Cookies.get("Doctor_details");
  const [loading, setLoading] = useState(true);
  let Doctor_details = {};

  if (doctorDetailsCookie) {
    try {
      Doctor_details = JSON.parse(doctorDetailsCookie);
    } catch (error) {
      console.log("Error parsing Doctor_details cookie:", error);
    }
  }
  const id = queryParams.get(Doctor_details.PID);
  const fileInputRef = useRef(null);

  const { getDoctorDetails, DoctorDetails } = TeleConsultationStore();
  const [doctorData, setDoctorData] = useState({});

  useEffect(() => {
    getDoctorDetails(id);
  }, [id]);

  useEffect(() => {
    if (Doctor_details) {
      setDoctorData(Doctor_details);
    }
  }, []);

  const handleChange = (e, key) => {
    setDoctorData((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const navigate = useNavigate();

  const submit = async () => {
    try {
      if (!doctorData.UID || !doctorData.PID) {
        alert("Doctor UID or PID missing! Cannot update.");
        return;
      }

      const payload = {
        UID: doctorData.UID,
        PID: doctorData.PID,
        name: doctorData.name,
        speciality: doctorData.speciality,
        experience: doctorData.experience,
        phone: doctorData.phone,
        email: doctorData.email,
        Signature: doctorData.Signature,
        treated: doctorData.treated,
        rating: doctorData.rating,
        about: doctorData.about,
        timing: doctorData.timing,
        schedule: doctorData.schedule,
        audio_consultation_charges: doctorData.audio_consultation_charges,
        img: doctorData.img,
        course_details: doctorData.course_details,
        language_known: doctorData.language_known,
        video_consultation_charges: doctorData.video_consultation_charges,
        discount: doctorData.discount,
      };


      const response = await teleConsultationModel.post(
        "/UpdateDoctor",
        payload
      );
      navigate(`/profile`);
      if (response.status === 200) {
        alert("Profile Updated Successfully!");
      } else {
        alert("Failed to update profile.");
      }
    } catch (error) {
      console.error("Error:", error?.response?.data || error);
      alert("Error updating profile. Please try again.");
    }
  };

  // Handle Profile Image Change
  const [image, setImage] = useState(
    DoctorDetails?.img || "placeholder-image-url"
  );

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64data = reader.result.split(",")[1]; // Extract base64 data

        try {
          const uploadResponse = await profileModel.post(
            "/UpdateProfilepicture",
            {
              UID: doctorData.UID, // Assuming doctorData has UID
              data: base64data,
              filename: file.name,
            }
          );

          if (uploadResponse.status === 200) {
            const imageUrl = uploadResponse.data.data;
            setDoctorData((prev) => ({ ...prev, img: imageUrl })); // Save to doctorData state
            setImage(imageUrl);
          }
        } catch (err) {
          console.log(err?.response?.data);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex flex-col bg-white">
      {/* {loading && <LoadingComponent loading={profileModel} />} */}

      <div className="self-stretch bg-white h-auto p-2 ">
        <div className="flex items-center self-stretch bg-[#FAF6EC] p-3 mb-5 mr-5 rounded-md">
          <Link to="/profile">
            <div className="flex items-center text-[#3B362A] text-lg font-medium cursor-pointer">
              <img
                src="./icons/tabler-icon-arrow-left.png"
                className="w-6 h-6 mr-2 object-fill"
                alt="Back Icon"
              />
              Profile
            </div>
          </Link>
        </div>

        <div className="flex items-start self-stretch mb-14 ">
          
          <div className="Tele-consultation-doctor-details flex flex-1 flex-col">
            
            <div className="relative mr-3 ">
              {/* Doctor's Image */}
              <img
                src="/icons/EditIconWithWhite.png"
                alt="Edit"
                className="absolute cursor-pointer bg-white p-1 rounded-full shadow-md"
                style={{
                  top: "8px",
                  right: "8px",  
                  width: "40px", 
                  height: "40px",
                }}
                onClick={() => fileInputRef.current.click()}
              />

              <img
                src={image}
                alt={DoctorDetails?.name || "Doctor Image"}
                className="w-full h-full object-cover pb-4 rounded-md"
              />

              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                className="hidden"
                onChange={handleImageChange}
              />

              {/* Edit Icon - Positioned Correctly */}
            </div>
            <div className="mb-2">
              <span className="text-[#3B362A] text-lg font-medium">Bio</span>
            </div>
            <textarea
              className=" text-[#3B362A] bg-[#F8F8F4] text-ml border border-[#D1D5DB] focus:border-[#75623F]  mr-3 p-2 rounded-md text-lg h-40 resize-none"
              value={doctorData.about || ""}
              onChange={(e) => handleChange(e, "about")}
            />
          </div>

          <div className="flex flex-1 flex-col items-start mt-1 mb-1 mr-2">
            <div className="grid grid-cols-2 gap-4 w-full">
              {[
                { label: "Name", key: "name" },
                { label: "Registration Number", key: "regno" },
                { label: "Qualification", key: "course_details" },
                { label: "Specialization", key: "speciality" },
                { label: "Years of Experience", key: "experience" },
                { label: "Languages Known", key: "language_known" },
                { label: "Phone", key: "phone" },
                { label: "Email", key: "email" },
                { label: "Total Patients Treated", key: "treated" },
              ].map(({ label, key }, index) => (
                <div key={index} className="flex flex-col items-start ">
                  <span className="text-[#3B362A] text-lg mb-2">{label}</span>
                  <input
                    className="w-full text-[#3B362A] bg-[#F8F8F4] text-ml p-2 rounded-md border border-[#D1D5DB] focus:border-[#75623F] outline-none"
                    value={doctorData[key] || ""}
                    onChange={(e) => handleChange(e, key)}
                  />
                </div>
              ))}
            </div>
            <div className="flex flex-col self-stretch mb-10 mt-4">
              <button
                className="bg-[#DA6E0B] text-white text-lg font-bold py-3 px-14 rounded-lg border-0"
                onClick={submit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
